import { React, useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Table,
  CardTitle,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const LatestTransaction = () => {
  const [allOrder, setAllOrders] = useState([]);
  const [modal_scroll, setmodal_scroll] = useState(false);

  useEffect(() => {
    getOrders();
  }, []);

  const getOrders = async () => {
    const api = await fetch(
      `https://backendkwingy.online/api/products/orders/allorders`
    );
    const data = await api.json();
    console.log(data);
    setAllOrders(data.allOrders);
  };

  function tog_scroll() {
    setmodal_scroll(!modal_scroll);
    removeBodyCss();
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding");
  }

  return (
    <Col lg={8}>
      <Breadcrumbs title="UI Elements" breadcrumbItem="Modals" />
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">Latest Transaction</CardTitle>
          <div className="table-responsive">
            <Table className="table-centered">
              <thead>
                <tr>
                  <th scope="col">Placed By</th>
                  <th scope="col">Phone no.</th>
                  <th scope="col">Billing Name</th>
                  <th scope="col">Payment Method</th>
                  <th scope="col" colSpan="2">
                    Order Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {allOrder.map((order) => {
                  return (
                    <tr key={order._id}>
                      <td>{order.placedby}</td>
                      <td>
                        <Link to="#" className="text-body fw-medium">
                          {order.phonenumber}
                        </Link>
                      </td>
                      <td>{order.fullname}</td>
                      <td>{order.paymentmethod}</td>
                      <td>
                        <span className="badge badge-soft-success font-size-12">
                          {order.orderstatus}
                        </span>
                      </td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary waves-effect waves-light"
                          onClick={() => {
                            tog_scroll();
                          }}
                          data-toggle="modal"
                        >
                          View
                        </button>

                        <Modal
                          isOpen={modal_scroll}
                          toggle={() => {
                            tog_scroll();
                          }}
                          scrollable={true}
                        >
                          <div className="modal-header">
                            <h5 className="modal-title mt-0">
                              Order ID : {order._id}
                            </h5>
                            <button
                              type="button"
                              onClick={() => setmodal_scroll(false)}
                              className="close"
                              data-dismiss="modal"
                              aria-label="Close"
                            >
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div className="modal-body">
                            <p>Placed By : {order.placedby}</p>
                            <p>Billing Name : {order.fullname}</p>
                            <p>Delivery address : {order.deliveryaddress}</p>
                            <p>Delivery Location : {order.deliverylocation}</p>
                            <p>Delivery Fee : $ {order.deliveryfee}</p>
                            <p>Phone Number : {order.phonenumber}</p>
                            <p>Whatsapp Number : {order.whatsappphonenumber}</p>
                            <p>
                              OrderList :
                              <ul>
                                {order.ordersList.map((suborder) => {
                                  return (
                                    <li key={suborder.id}>
                                      {" "}
                                      Item Name : {suborder.name} . Price : ${" "}
                                      {suborder.price} . Quantity :{" "}
                                      {suborder.qty}
                                    </li>
                                  );
                                })}
                              </ul>
                            </p>
                            <p>Payment Method : {order.paymentmethod}</p>
                            <p>Order Status : {order.orderstatus}</p>
                            <p>Created At: {order.createdAt}</p>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setmodal_scroll(false)}
                              >
                                Close
                              </button>
                            </div>
                          </div>
                        </Modal>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          <div className="mt-3">
            <Pagination className="pagination pagination-rounded justify-content-center mb-0">
              <PaginationItem>
                <PaginationLink to="#">Previous</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink to="#">1</PaginationLink>
              </PaginationItem>
              <PaginationItem className="active">
                <PaginationLink to="#">2</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink to="#">3</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink to="#">Next</PaginationLink>
              </PaginationItem>
            </Pagination>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default LatestTransaction;
